import { t } from "i18next";

import { DealerAuctionDTO, UserDTO } from "@/src/types/types";

export const getPickupIncludedText = (auction: DealerAuctionDTO): string => {
  if (
    auction.myHighestBid?.pickupIncluded === true ||
    auction.ourHighestBid?.pickupIncluded === true ||
    auction.myHighestBid?.pickupIncluded === false ||
    auction.ourHighestBid?.pickupIncluded === false
  ) {
    return auction.myHighestBid?.pickupIncluded ||
      auction.ourHighestBid?.pickupIncluded
      ? t("general.yes")
      : t("general.no");
  }
  return "-";
};

export const checkForUnreadMessages = (
  auction: DealerAuctionDTO | null,
  user: UserDTO | null | undefined
): boolean => {
  if (!auction || !user) {
    return false;
  }
  const bidderUserId =
    auction.myHighestBid?.userId ?? auction.ourHighestBid?.userId ?? 0;
  const hasUnreadMessages =
    auction && auction?.negotiationMessages
      ? Object.values(auction.negotiationMessages)
          .flat()
          .some((message) => !message.isRead && bidderUserId === user.id)
      : false;
  return hasUnreadMessages;
};
